function BlogsComponents() {
    return (
        <div>
            <h1>Blogs components</h1>
        </div>
    )
}

export default BlogsComponents
